export default __webpack_public_path__ + "static/media/Ltst-4.41d84077.jpg";